import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SegmentLoader, ButtonGroup, Button, Row, Col } from '@si-armes/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import PropTypes from 'prop-types';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_ADRESSES_SECONDAIRES_URL,
    API_POST_VERIFIER_BAN,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES,
    CONTEXT_POST_VERIFIER_BAN,
} from 'constants/apiUrls.constants';
import TableAdressesComponent from 'components/table/TableAdressesComponent';
import FormulaireAdresseSimple from 'components/form/formulaireAdresse/FormulaireAdresseSimple';
import ModalBan from 'components/modalBan/ModalBan';
import FormaterCreationListeAdressesSecondaires from './FormaterCreationListeAdressesSecondaires';
import InfoChampsObligatoire from '../../../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const CreerCompteAdresseSecondaire = ({
    uuidBrouillon,
    setEtapeAdresse,
    retourEtape,
    postApi,
    reinitialiseApi,
    dataBan,
    isLoadingBan,
    isLoadingAjoutAdresseSecondaire,
    dataAjoutAdresseSecondaire,
    dataAdressesSecondairesRenseignee,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
        criteriaMode: 'all',
    });

    const { handleSubmit, setValue } = hookForm;

    const [listeAdresses, setListeAdresses] = useState(dataAdressesSecondairesRenseignee);

    const [affichageFormulaire, setAffichageFormulaire] = useState(false);

    const [dataToSubmit, setDataToSubmit] = useState(null);
    const [ouvrirModalBan, setOuvrirModalBan] = useState(false);

    useEffect(() => {
        if (
            !isLoadingAjoutAdresseSecondaire &&
            dataAjoutAdresseSecondaire &&
            dataAjoutAdresseSecondaire.uuidBrouillon
        ) {
            setOuvrirModalBan(false);
        }
    }, [isLoadingAjoutAdresseSecondaire, dataAjoutAdresseSecondaire]);

    const afficherFormulaire = () => {
        setAffichageFormulaire(true);
    };

    const suppressionLigneTableau = (table, index) => {
        table.splice(index, 1);
        return [...table];
    };

    const supprimerLigne = (idBouton) => {
        setListeAdresses(suppressionLigneTableau(listeAdresses, idBouton));
    };

    const getActions = (idBouton) => {
        return (
            <>
                <Button
                    icon="fr-fi-delete-fill"
                    variant="secondary"
                    onClick={() => supprimerLigne(idBouton)}
                    aria-label="Supprimer une adresse secondaire"
                    type="button"
                />
            </>
        );
    };

    const addToListeAdresse = (data) => {
        setListeAdresses([...listeAdresses, data]);
    };

    const resetForm = () => {
        setValue('numeroDeVoie', '');
        setValue('extension', '');
        setValue('typeEtNomDeVoie', '');
        setValue('lieuDit', '');
        setValue('codePostal', '');
        setValue('ville', '');
    };

    const cacherFormulaire = () => {
        setAffichageFormulaire(false);
        resetForm();
        return (
            <>
                <TableAdressesComponent listeAdresses={listeAdresses} actions={getActions} />
                <Button
                    icon="fr-icon-add-line"
                    iconPosition="left"
                    name="ajouterAdresse"
                    variant="secondary"
                    onClick={afficherFormulaire}
                >
                    Ajouter une adresse de résidence secondaire
                </Button>
            </>
        );
    };
    // on mount et unmount
    useEffect(() => {
        window.scrollTo(0, 0);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES);
        return () => {
            reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
            reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES);
        };
    }, []);

    const requetePostAdresse = (donnees) => {
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES);
        postApi(
            usagerClientReducer,
            API_COMPTE_CREER_ADRESSES_SECONDAIRES_URL,
            donnees,
            CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES,
        );
    };

    useEffect(() => {
        if (isLoadingAjoutAdresseSecondaire === false && dataAjoutAdresseSecondaire) {
            setEtapeAdresse(listeAdresses);
        }
    }, [isLoadingAjoutAdresseSecondaire, dataAjoutAdresseSecondaire]);

    const verifierBan = (data) => {
        const adresseAverifier = {
            numeroVoie: data.numeroDeVoie,
            libelleVoie: data.typeEtNomDeVoie,
            codePostal: data.codePostal,
            ville: data.ville,
            extension: data.extension,
            lieuDit: data.lieuDit,
        };

        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        postApi(
            usagerClientReducer,
            API_POST_VERIFIER_BAN,
            adresseAverifier,
            CONTEXT_POST_VERIFIER_BAN,
        );
        setDataToSubmit(data);
        setOuvrirModalBan(true);
    };

    const onRetourEtape = () => {
        setAffichageFormulaire(false);
        resetForm();
        retourEtape(listeAdresses);
    };

    const onEtapeSuivante = async () => {
        const data = FormaterCreationListeAdressesSecondaires(listeAdresses, uuidBrouillon);
        requetePostAdresse(data);
        setAffichageFormulaire(false);
        resetForm();
    };

    const fermerModal = () => {
        setOuvrirModalBan(false);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
    };

    const conserver = () => {
        fermerModal();
        addToListeAdresse({ ...dataToSubmit, hasVerificationBan: false });
        setAffichageFormulaire(false);
        resetForm();
    };

    const remplacer = () => {
        fermerModal();
        addToListeAdresse({
            ...dataToSubmit,
            numeroDeVoie: dataBan.numeroVoie,
            typeEtNomDeVoie: dataBan.libelleVoie,
            extension: dataBan.extension,
            lieuDit: dataBan.lieuDit,
            codePostal: dataBan.codePostal,
            ville: dataBan.ville,
            hasVerificationBan: true,
        });
        setAffichageFormulaire(false);
        resetForm();
    };

    return (
        <div>
            <SegmentLoader isLoading={isLoadingAjoutAdresseSecondaire}>
                {ouvrirModalBan && (
                    <ModalBan
                        residence="secondaire"
                        fermerModal={fermerModal}
                        data={dataBan}
                        isLoading={isLoadingBan}
                        remplacer={remplacer}
                        conserver={conserver}
                    />
                )}
                <TableAdressesComponent listeAdresses={listeAdresses} actions={getActions} />
                {affichageFormulaire ? (
                    <FormProvider {...hookForm}>
                        <form onSubmit={handleSubmit(verifierBan)}>
                            <Row>
                                <Col col={12}>
                                    <InfoChampsObligatoire />
                                </Col>
                            </Row>
                            <FormulaireAdresseSimple />
                            <Row className="margin-top-lg">
                                <Col>
                                    <ButtonGroup inline align="right">
                                        <Button
                                            name="Annuler"
                                            variant="secondary"
                                            onClick={cacherFormulaire}
                                        >
                                            Annuler
                                        </Button>
                                        <Button
                                            name="validerAdresse"
                                            type="submit"
                                            variant="primary"
                                        >
                                            Valider
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </form>
                    </FormProvider>
                ) : (
                    <div>
                        <Button
                            name="ajouterAdresse"
                            variant="secondary"
                            onClick={afficherFormulaire}
                            icon="fr-icon-add-line"
                            iconPosition="left"
                        >
                            Ajouter une adresse de résidence secondaire
                        </Button>
                    </div>
                )}
                <Row className="margin-top-lg">
                    <Col>
                        <ButtonGroup inline align="right">
                            <Button
                                isLoading={isLoadingAjoutAdresseSecondaire}
                                name="etapePrecedente"
                                variant="secondary"
                                onClick={onRetourEtape}
                            >
                                Retour
                            </Button>
                            <Button
                                isLoading={isLoadingAjoutAdresseSecondaire}
                                name="etapeSuivante"
                                variant="primary"
                                onClick={onEtapeSuivante}
                                disabled={affichageFormulaire}
                            >
                                Accéder à l'étape suivante
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </SegmentLoader>
        </div>
    );
};

CreerCompteAdresseSecondaire.propTypes = {
    uuidBrouillon: PropTypes.string.isRequired,
    setEtapeAdresse: PropTypes.func.isRequired,
    retourEtape: PropTypes.func.isRequired,
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoadingBan: PropTypes.bool,
    dataBan: PropTypes.any,
    isLoadingAjoutAdresseSecondaire: PropTypes.bool,
    dataAjoutAdresseSecondaire: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    dataAdressesSecondairesRenseignee: PropTypes.arrayOf(
        PropTypes.shape({
            hasVerificationBan: PropTypes.bool,
            numeroDeVoie: PropTypes.string,
            typeEtNomDeVoie: PropTypes.string.isRequired,
            extension: PropTypes.string,
            lieuDit: PropTypes.string,
            codePostal: PropTypes.string.isRequired,
            ville: PropTypes.string.isRequired,
        }),
    ),
};

export default connect(
    (state) => {
        const { isLoading: isLoadingAjoutAdresseSecondaire, data: dataAjoutAdresseSecondaire } =
            state.compte.creer.ajoutAdresseSecondaire;
        const { isLoading: isLoadingBan, data: dataBan } = state.adresseVerificationBAN.verifier;
        return {
            isLoadingBan,
            dataBan,
            isLoadingAjoutAdresseSecondaire,
            dataAjoutAdresseSecondaire,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(CreerCompteAdresseSecondaire);
